var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87191 10C1.53514 10 1.25008 9.88333 1.01675 9.65C0.783415 9.41667 0.666748 9.13161 0.666748 8.79483V1.20517C0.666748 0.868389 0.783415 0.583333 1.01675 0.35C1.25008 0.116667 1.53514 0 1.87191 0H12.1282C12.465 0 12.7501 0.116667 12.9834 0.35C13.2167 0.583333 13.3334 0.868389 13.3334 1.20517V8.79483C13.3334 9.13161 13.2167 9.41667 12.9834 9.65C12.7501 9.88333 12.465 10 12.1282 10H1.87191ZM12.3334 1.9615L7.32441 5.168C7.27319 5.197 7.22019 5.21983 7.16542 5.2365C7.11075 5.25317 7.05564 5.2615 7.00008 5.2615C6.94453 5.2615 6.88941 5.25317 6.83475 5.2365C6.77997 5.21983 6.72697 5.197 6.67575 5.168L1.66675 1.9615V8.79483C1.66675 8.85472 1.68597 8.90389 1.72441 8.94233C1.76286 8.98078 1.81203 9 1.87191 9H12.1282C12.1881 9 12.2373 8.98078 12.2757 8.94233C12.3142 8.90389 12.3334 8.85472 12.3334 8.79483V1.9615ZM7.00008 4.33333L12.2309 1H1.76925L7.00008 4.33333ZM1.66675 2.11533V1.35317V1.373V1.35183V2.11533Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailgrey);
export default __webpack_public_path__ + "static/media/mail grey.40c4bcde766242684af3dd86c86a5396.svg";
export { ForwardRef as ReactComponent };